import { lazy } from 'react';

const RELOAD_AT = 'chunk-reload-at';
const RELOAD_INTERVAL = 60 * 1000;

function storage(method, ...args) {
  try {
    return window.sessionStorage[method](...args);
  } catch {
    return null;
  }
}

// A deploy renames the hashed chunks, so a tab still holding the previous
// bundle fails to import them. Reload to pick up the new index.html instead of
// surfacing the router's error page. At most one reload per interval per tab:
// a cached parent chunk can still load after a reload while a stale child
// fails, so the guard must not reset on success or the page would loop.
export function importWithReload(factory) {
  return factory().catch(error => {
    if (Date.now() - Number(storage('getItem', RELOAD_AT)) < RELOAD_INTERVAL) {
      throw error;
    }
    storage('setItem', RELOAD_AT, String(Date.now()));
    window.location.reload();
    return new Promise(() => {});
  });
}

export default function lazyWithReload(factory) {
  return lazy(() => importWithReload(factory));
}
